<inventory-id-selector [inventoryID]="inventoryID" (onSubmit)="checkForQty($event)" (onChange)="addItem($event)"
    #itemSelector>
</inventory-id-selector>

<table style="width:100%;">
    <tr *ngFor="let inv of inventory">
        <td>{{inv.item.InventoryID}}</td>
        <td>{{inv.item.Description}}</td>
        <td>{{inv.qty}}</td>
    </tr>
</table>

<button mat-raised-button color="primary" (click)="createReceipt()" style="width:100%; margin-top:1.5em;">Adjust in
    Inventory</button>